import history from 'providers/history';
import { isInternalHref, toInternalPath } from 'services/urlService';

const isBlacklisted = (href) => {
  const { pathname } = new URL(href);

  return [
    '/manage',
  ].find(exclude => pathname?.indexOf(exclude) === 0);
};

const userContentClickHandler = (e) => {

  const anchor = e.target?.closest('[data-user-content]');

  if (!anchor) {
    return;
  }

  const { href } = anchor;

  if (isInternalHref(href) && !isBlacklisted(href)) {
    history.push(toInternalPath(href));
    e.preventDefault();
  }
};

const init = () => {
  document.addEventListener('click', userContentClickHandler, false);
};

export default init;
